module.exports = __webpack_public_path__ + "img/2.b34b151b.png";